import React, { useEffect, useState } from "react";
import Edit from "../../Assets/img/Edit.svg";
import { useNavigate } from "react-router-dom";
import "../Consultation/Consultation.css";
import Search from "../../Assets/img/search.png";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";

const Consultation = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [consultation, setConsultation] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);

    const redirectMap = {
        "intake form": "IntakeFormEdit",
        "formulaire d'admission": "IntakeFormEdit",
    };


    const normalize = (str) =>
        str.replace(/\s+/g, " ").trim().toLowerCase();

    const fetchConsultation = () => {
        setLoading(true);

        let payload = { search, status, language_id: languageId, };

        API.post("consultation_list/condition", payload)
            .then((response) => {
                const list = response?.data?.data?.data || [];

                const updatedList = list.map((item) => {
                    const key = normalize(item.consultation_name);
                    return {
                        ...item,
                        redirect: redirectMap[key] || "",
                        consultation_id: item.consultation_id

                    };
                });

                setConsultation(updatedList);
            })
            .catch((err) => {
                console.error("Error:", err);
                setConsultation([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchConsultation();
    }, []);


    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        setLoading(true); // Show loader during update

        API.post("consultation_status/update", {
            consultation_id: id,
            status: newStatus,
        })
            .then(() => fetchConsultation())
            .catch((err) => console.error("Failed to update status:", err))
            .finally(() => setLoading(false));
    };
    const filteredConsultation = consultation.filter(
        (item) => item.consultation_name
    );
    return (
        <div className="services-container1">

            {/* HEADER */}
            <div className="services-header1">
                <h2 className="services-title1">Consultation</h2>

            </div>

            {/* FILTER SECTION */}
            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search Consultation..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div
                    className="filter-btn-wrapper"
                    onClick={() => fetchConsultation()}
                >
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    {/* OTHER SERVICES */}
                    <div className="services-grid3">
                        {filteredConsultation.length > 0 ? (
                            filteredConsultation.map((item) => (
                                <div className="services-card1" key={item.consultation_id}>
                                    <p>{item.consultation_name}</p>

                                    <div className="card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(
                                                            item.consultation_id,
                                                            item.status
                                                        )
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-btn1"
                                                onClick={() =>
                                                    navigate(`/${item.redirect}?lang=${languageId}`)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-news-text">No Consultation found.</p>
                        )}
                    </div>

                </>
            )}
        </div>
    );
};

export default Consultation;
